var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./ProductionDesignInitiativeApplicationAgreement.jinja');
require('./ProductionDesignInitiativeApplicationAgreement.less');


module.exports = Base.extend({

    template: template,

    events: {
        'click': 'onBGClick',
        'click .ProductionDesignInitiativeApplicationAgreement-close': 'onCloseClick'
    },


    initialize: function (options) {

        _.bindAll(this, 'onKeyDown');

        this.$el.appendTo('body');

        Base.prototype.initialize.call(this, options);
    },


    show: function (params) {
        var $popup = params.$parent.closest('.BasePopup');

        $('body').on('keydown', this.onKeyDown);

        clearTimeout(this.hideTimeout);

        this.savedScroll = $(window).scrollTop();

        $popup
            .addClass('FixedOnPopup')
            .outerHeight();

        $popup.css('top', -this.savedScroll + 'px');

        this.$el.show();
        this.$el.outerHeight();
        this.$el.addClass('ProductionDesignInitiativeApplicationAgreement--visible');
    },


    hide: function () {
        $('body').off('keydown', this.onKeyDown);

        clearTimeout(this.hideTimeout);

        this.$el.removeClass('ProductionDesignInitiativeApplicationAgreement--visible');

        this.hideTimeout = setTimeout(function () {
            this.$el.hide();

            $('.BasePopup')
                .removeClass('FixedOnPopup')
                .outerHeight();

            $('.BasePopup').css('top', '');

            $(window).scrollTop(this.savedScroll);
        }.bind(this), 500);
    },


    onBGClick: function (e) {
        if ($(e.target).closest('.ProductionDesignInitiativeApplicationAgreement-body').length) return;

        this.hide();
    },


    onCloseClick: function () {
        this.hide();
    },


    onKeyDown: function (e) {
        if (e.keyCode == 27) { //esc
            e.stopPropagation();

            this.hide();
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/ProductionDesignInitiativeApplicationAgreement/ProductionDesignInitiativeApplicationAgreement.js
// module id = 234
// module chunks = 0